document.addEventListener('DOMContentLoaded', function() {
  const filterOpenButton = document.querySelector('.navigation--filter .navigation--button');
  const mobileMenuButton = document.querySelector('.navigation--mobile-button'); // Nút mobile bạn muốn thêm
  const filterForm = document.querySelector('.filter--form');

  // Hàm dùng chung để đóng các menu con
  const closeAllFilterSubMenus = function() {
    if (!filterForm) return;
    
    const filterToggles = filterForm.querySelectorAll('.filter--toggle');
    filterToggles.forEach(toggle => {
      console.log('Resetting filter states');
      toggle.setAttribute('aria-expanded', 'false');
      
      const interactiveEl = toggle.querySelector('[aria-expanded]');
      if (interactiveEl) {
        interactiveEl.setAttribute('aria-expanded', 'false');
      }
    });
  };

  // Gán sự kiện cho nút Filter gốc
  if (filterOpenButton) {
    filterOpenButton.addEventListener('click', closeAllFilterSubMenus);
  }

  // Gán sự kiện cho nút Navigation Mobile
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', closeAllFilterSubMenus);
  }
});